export const saveSlider = [
  '',
  `mutation saveSlider($input: SliderInput!) {
        saveSlider(content:$input) {
        id
      }
    }`,
  'saveSlider',
];
